module.exports = __webpack_public_path__ + "static/media/scene5_didi1.1d69f7fc.wav";